/**
 * "Allow agents to insert and update table data" on an internal table's settings dialog.
 *
 * The checkbox applies to an existing internal table only: external tables are read-only for
 * agents, and a table that is still being created has no row to hold the setting yet.
 */

/** Dialog types that mean "an existing internal table". `View` is how the dialog opens one. */
export function isAgentWriteTableDialog(
    dialogType: string | undefined,
    isExternalDialog: boolean,
    tableName: string | undefined
): boolean {
    return dialogType === 'View' && !isExternalDialog && !!tableName;
}

/** Read the saved setting from a `get-table-meta` payload. Anything but `true` is off. */
export function readAllowAgentWrite(meta: unknown): boolean | null {
    if (!meta || typeof meta !== 'object') return null;
    const value = (meta as { allowAgentWrite?: unknown }).allowAgentWrite;
    if (value === undefined || value === null) return null;
    return value === true;
}

/** Only call the API when the box was actually changed since the dialog loaded it. */
export function agentWriteNeedsSave(
    initial: boolean,
    current: boolean | null | undefined
): boolean {
    return typeof current === 'boolean' && current !== initial;
}
